import { FiltersTrackingLocation, useTrackReturnedEmptyFiltersResult } from '@air/analytics';
import { useShortIdContext } from '@air/provider-short-id';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getPublicSearchTotalKey } from '~/constants/react-query-keys';
import { useFilterParams } from '~/hooks/filters/useFilterParams';
import { useFiltersContext } from '~/providers/FiltersProvider';
import { useClipSearchParams } from '~/swr-hooks/search/useClipSearchParams';
import { getTypesToFetchFromParams } from '~/swr-hooks/search/utils';
import { SearchTotals } from '~/types/SearchTotals';
import { filterParamsToTrackingType } from '~/utils/filters/filtersToUrlParamsUtils';

export const usePublicSearchTotals = ({ trackLocation }: { trackLocation: FiltersTrackingLocation }) => {
  const { shortId } = useShortIdContext();
  const { typesParam } = useFilterParams();
  const clipsFetchParams = useClipSearchParams();
  clipsFetchParams.types = getTypesToFetchFromParams(typesParam);
  const { trackReturnedEmptyFiltersResult } = useTrackReturnedEmptyFiltersResult();
  const queryClient = useQueryClient();
  const {
    filters: { customFields, ...filters },
  } = useFiltersContext();

  const { data } = useQuery({
    queryKey: getPublicSearchTotalKey(shortId),

    queryFn: async () => {
      const data = queryClient.getQueryData<SearchTotals>(getPublicSearchTotalKey(shortId));

      const total = data?.total ?? 0;

      if (!total) {
        trackReturnedEmptyFiltersResult({
          types: filterParamsToTrackingType({ ...filters, ...customFields }),
          location: trackLocation,
        });
      }

      return { total };
    },
  });

  return {
    total: data?.total,
  };
};
